import apiClient, { API_ENDPOINTS, dispatchAndResolve, rejectWithError } from "api";
import {
  buildDocumentUploadFormData,
  buildFileLookupCriteria
} from "domains/storage/services/fileRequestBuilders";
import * as types from "./types.jsx";

const { applicant, fileStore, upload } = API_ENDPOINTS;

const rejectS3Error = (error, label) => rejectWithError(error, label);

export const uploadDocument = (file, userId) => async (dispatch) => {
  try {
    const objectUrl = await apiClient.upload(
      upload.uploadDocument,
      buildDocumentUploadFormData(file, userId)
    );

    if (!objectUrl) {
      throw new Error("No data received from server");
    }

    return dispatchAndResolve(dispatch, types.DOCUMENT_UPLOAD_SUCCESS, objectUrl);
  } catch (error) {
    dispatch({ type: types.DOCUMENT_UPLOAD_FAILURE, payload: error?.payload || error });
    return rejectS3Error(error, "Error uploading document");
  }
};

export const getFile = (bucketName, userId) => async (dispatch) => {
  try {
    const s3Url = await apiClient.post(
      upload.getFileByUserId,
      buildFileLookupCriteria(bucketName, userId)
    );

    if (!s3Url) {
      throw new Error("No data received from server");
    }

    return dispatchAndResolve(dispatch, types.GET_FILE_SUCCESS, s3Url);
  } catch (error) {
    const errorMessage = error?.status === 404
      ? "File not found"
      : error?.status === 500
        ? "Internal Server Error"
        : error?.message || "An unexpected error occurred";

    dispatch({ type: types.GET_FILE_FAILURE, payload: errorMessage });
    return rejectS3Error(error, "Error getting file");
  }
};

export const deleteFile = (bucketName, userId) => async (dispatch) => {
  try {
    const data = await apiClient.post(
      upload.deleteFileByUserId,
      buildFileLookupCriteria(bucketName, userId)
    );

    if (!data) {
      throw new Error("No data received from server");
    }

    return dispatchAndResolve(dispatch, types.DELETE_FILE_SUCCESS, data);
  } catch (error) {
    dispatch({ type: types.DELETE_FILE_FAILURE, payload: error?.payload || error });
    return rejectS3Error(error, "Error deleting file");
  }
};

export const downloadFileFromStore = (key) => async () => {
  try {
    return await apiClient.get(fileStore.download, {
      query: { key },
      responseType: "blob"
    });
  } catch (error) {
    return rejectS3Error(error, "Error downloading file from store");
  }
};

export const uploadResume = (resumeDetails) => async (dispatch) => {
  try {
    const data = await apiClient.upload(upload.uploadResumeFile, resumeDetails);
    return dispatchAndResolve(dispatch, types.UPLOAD_RESUME, data);
  } catch (error) {
    dispatch({ type: types.UPLOAD_RESUME_FAIL, payload: error?.payload || error });
    return rejectS3Error(error, "Error uploading resume");
  }
};

export const createApplicant = (applicantPayload) => async (dispatch) => {
  try {
    const data = await apiClient.post(applicant.addApplicant, applicantPayload);
    return dispatchAndResolve(dispatch, types.CREATE_APPLICANT, data);
  } catch (error) {
    dispatch({ type: types.CREATE_APPLICANT_FAIL, payload: error?.payload || error });
    return rejectS3Error(error, "Error creating applicant");
  }
};
